<template>
  <div>
    <h1>Editar Tarifa plana</h1>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Nombre de tarifa plana">
                <a-input ref="name" placeholder="Nombre" v-model="$v.fixedFare.name.$model" />
                <small class="text-danger" v-if="!$v.fixedFare.name.required">Campo requerido. No debe estar vacío.</small><br>
                <!--<small class="text-danger" v-if="!validateRegisteredName($v.fixedFare.name.$model)">Ya existe un registro con este origen y destino</small>-->
              </a-form-item>
            </div>
            <!--
            <div class="col-md-6">
              <a-form-item label="Origen">
                <v-select label="name" :options="getAllSources" v-model="$v.fixedFare.origin.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.fixedFare.origin.required">Campo requerido. No debe estar vacío.</small>
                <small class="text-danger" v-if="!validateRegisteredOriginAndDestiny($v.fixedFare.origin.$model, $v.fixedFare.destination.$model)">Ya existe un registro con este origen y destino</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Destino">
                <v-select label="name" :options="getAllDestinations" v-model="$v.fixedFare.destination.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.fixedFare.destination.required">Campo requerido. No debe estar vacío.</small>
                <small class="text-danger" v-if="!validateRegisteredOriginAndDestiny($v.fixedFare.origin.$model, $v.fixedFare.destination.$model)">Ya existe un registro con este origen y destino</small>
              </a-form-item>
            </div>-->
            <div class="col-md-6">
              <a-form-item label="Kilómetros de ida">
                <a-input ref="name" placeholder="Kilometros" v-model="$v.fixedFare.km.$model" />
                <small class="text-danger" v-if="!$v.fixedFare.km.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!$v.fixedFare.km.decimal">Este campo debe ser decimal</small><br>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Costo de vialidad">
                <a-input ref="name" placeholder="Costo de vialidad" v-model="$v.fixedFare.freeRoadFare.$model" />
                <small class="text-danger" v-if="!$v.fixedFare.freeRoadFare.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!$v.fixedFare.freeRoadFare.decimal">Este campo debe ser numérico</small><br>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Vialidad">
                <v-select disabled="true" label="name" :options="['Carretera libre', 'Caseta']" v-model="$v.type.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.type.required">Campo requerido. No debe estar vacío.</small>
                <!--<small class="text-danger" v-if="!$v.fixedFare.tollwayFare.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!$v.fixedFare.tollwayFare.decimal">Este campo debe ser numérico</small><br>-->
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Hora pico">
                <a-checkbox v-model="rushHour">
                  Hora pico
                </a-checkbox>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Preferente">
                <a-checkbox v-model="preferential">
                  Preferente
                </a-checkbox>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button ref="button" type="submit" class="btn btn-light px-5" :disabled="!(!$v.$invalid)">
                  Registrar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
    <!--
    <FareList ref="listComponent" >
    </FareList>
    -->
  </div>
</template>
<script>
import { required, decimal } from 'vuelidate/lib/validators'
// import FareList from './fare-list/fare-list'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const GET_ALL_SOURCES = gql`
  query getAllSources{
    getAllSources{
      id
      name
    }
  }
`
const GET_ALL_DESTINATIONS = gql`
  query getAllDestinations{
    getAllDestinations{
      id
      name
      createdBy
    }
  }
`
const GET_ALL_FIXED_FARES = gql`
query getAllFIxedFares{
  getAllFIxedFares {
    id
    name
    preferential
    source {
      id
      name
    }
    destination{
      id
      name
    }
  }
}
`
const UPDATE_FIXED_FARE = gql`
mutation updatefixedFare($fixedFareId: Int, $updatedBy: String, $name: String, $freeRoadFare: Float, $tollwayFare: Float, $kmTotal: Float $rushHour: Boolean, $preferential: Int){
  updatefixedFare(fixedFareId: $fixedFareId fixedFareRequest: { name: $name freeRoadFare: $freeRoadFare tollwayFare: $tollwayFare kmTotal: $kmTotal rushHour: $rushHour, updatedBy: $updatedBy preferential: $preferential}){
    id
    name
    freeRoadFare
    preferential
  }
}
`
export default {
  components: {
    // FareList,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      type: '',
      preferential: false,
      pref: 0,
      fixedFare: {
        name: this.$route.params.name,
        origin: this.$route.params.source,
        destination: this.$route.params.destination,
        km: this.$route.params.kmTotal,
        freeRoadFare: this.$route.params.freeRoadFare,
        tollwayFare: this.$route.params.tollwayFare,
      },
      rushHour: this.$route.params.rushHour,
      getAllSources: [],
      getAllDestinations: [],
      registeredOriginAndDestiny: {},
      registeredName: {},
      createdBy: this.$store.state.user.email,
      updatedBy: this.$store.state.user.email,
    }
  },
  apollo: {
    getAllSources: {
      query: GET_ALL_SOURCES,
      result({ data }) {
      },
      error(error) {
        console.log(error)
      },
      context: headers(),
    },
    getAllDestinations: {
      query: GET_ALL_DESTINATIONS,
      result({ data }) {
        // console.log(data)
      },
      error(error) {
        console.log(error)
      },
      context: headers(),
    },
    getAllFIxedFares: {
      query: GET_ALL_FIXED_FARES,
      context: headers(),
      result({ data }) {
        data.getAllFIxedFares.forEach(fixedFare => {
          this.registeredOriginAndDestiny[[fixedFare.source.name, fixedFare.destination.name]] = 1
          this.registeredName[fixedFare.name] = 1
        })
        delete this.registeredName[this.fixedFare.name]
        delete this.registeredOriginAndDestiny[[this.fixedFare.origin.name, this.fixedFare.destination.name]]
        // console.log(this.registeredOriginAndDestiny)
      },
      error(error) {
        console.log(error)
      },
    },
  },
  methods: {
    handleSubmit() {
      console.log(this.preferential, 'pref')
      if (this.preferential === true) {
        this.pref = 1
      } else {
        this.pref = 0
      }
      console.log(this.fixedFare)
      this.$apollo.mutate({
        mutation: UPDATE_FIXED_FARE,
        variables: {
          fixedFareId: parseInt(this.$route.params.id),
          name: this.fixedFare.name + ' ' + this.type,
          freeRoadFare: parseFloat(this.fixedFare.freeRoadFare),
          // tollwayFare: parseFloat(this.fixedFare.tollwayFare),
          kmTotal: parseFloat(this.fixedFare.km),
          rushHour: this.rushHour,
          updatedBy: this.$store.state.user.email,
          preferential: this.pref,
        },
        context: headers(),
      })
        .then(data => {
          console.log(data)
          this.$router.push('/tarifasPlanas/tarifasPlanas')
        })
        .catch(error => {
          console.log(error)
        })
    },
    validateRegisteredOriginAndDestiny(origin, destiny) {
      if (this.registeredOriginAndDestiny[[origin.name, destiny.name]]) {
        return false
      } else {
        return true
      }
    },
    validateRegisteredName(name) {
      if (this.registeredName[name.trim()]) {
        return false
      } else {
        return true
      }
    },
  },
  created() {
    if (this.$route.params.preferential === null) {
      this.preferential = false
    } else if (this.$route.params.preferential === 1) {
      this.preferential = true
    } else {
      this.preferential = false
    }
    console.log(this.$route.params, 'route params')
    const free = this.$route.params.name.match('Carretera libre')
    if (free) {
      this.fixedFare.name = this.fixedFare.name.replace('Carretera libre', '')
      this.type = 'Carretera libre'
    }
    const tollway = this.$route.params.name.match('Caseta')
    if (tollway) {
      this.fixedFare.name = this.fixedFare.name.replace('Caseta', '')
      this.type = 'Caseta'
    }
    // console.log(this.$route.params.name.split('Caseta'))
  },
  validations: {
    type: { required },
    fixedFare: {
      name: { required },
      origin: { required },
      destination: { required },
      km: { required, decimal },
      freeRoadFare: { required, decimal },
      // tollwayFare: { required, decimal },
    },
  },
}
</script>
